import script from "./AssetsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsTable.vue?vue&type=script&setup=true&lang=js"

import "./AssetsTable.vue?vue&type=style&index=0&id=d5d4ce06&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5d4ce06"]])

export default __exports__